import * as React from "react";
import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";

const CONSENT_KEY = "sf_cookie_consent";

export function CookieConsent() {
  const [visible, setVisible] = React.useState(false);

  React.useEffect(() => {
    const timer = setTimeout(() => {
      try {
        const consent = localStorage.getItem(CONSENT_KEY);
        if (!consent) {
          setVisible(true);
        }
      } catch {
        // ignore storage errors
      }
    }, 0);
    return () => clearTimeout(timer);
  }, []);

  const accept = () => {
    try {
      localStorage.setItem(CONSENT_KEY, "accepted");
    } catch {
      // ignore
    }
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div className="fixed bottom-0 left-0 right-0 z-50 border-t bg-card p-4 shadow-lg">
      <div className="mx-auto flex max-w-5xl flex-col items-center justify-between gap-3 sm:flex-row">
        <p className="text-sm text-muted-foreground">
          We use cookies and similar technologies (including limited diagnostics/telemetry for stability and performance) to enhance your experience, analyze traffic, and ensure security. Telemetry is conservative for field roles on cellular. By continuing to use our site, you agree to our{" "}
          <Link to="/privacy-policy" className="font-medium text-primary underline">
            Privacy Policy
          </Link>{" "}
          and{" "}
          <Link to="/terms-of-service" className="font-medium text-primary underline">
            Terms of Service
          </Link>
          .
        </p>
        <Button onClick={accept} size="sm">
          Accept
        </Button>
      </div>
    </div>
  );
}
